export const PRICING_WS_TIMEOUT_MS = 10_000;
export const PRICING_FALLBACK_COOLDOWN_MS = 30_000;
export const PRICING_RECOVERY_CHECK_INTERVAL_MS = 10_000;
export const PRICING_TAB_INACTIVE_DISCONNECT_DELAY_MS = 5000;
/**
 * Max number of consecutive websocket recovery cycles before we give up and stay
 * on polling permanently. Without this ceiling the recovery loop retries forever,
 * spamming the console when the websocket server is unreachable. The counter is
 * reset on a successful connection or when the tab is refocused.
 */
export const PRICING_MAX_RECOVERY_ATTEMPTS = 3;
